import React, { FC, memo } from 'react';
import { Input } from 'udesk-ui';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface TemplateProps {
    isEdit?: boolean;
    value?: string;
    onChange?: (value: string) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { isEdit, value, onChange } = props;

    return isEdit ? (
        <Input.TextArea
            bordered
            autoSize
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
        />
    ) : (
        <ReactMarkdown children={value || ''} remarkPlugins={[remarkGfm]} />
    );
});

export default Template;
